window.addEventListener('load', () => {
  const buttons = document.querySelectorAll('.ClassCard-accordion-button');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const accordion = button.parentElement;
      const isActive = accordion.className.split(' ').includes('isActive');

      if (isActive) {
        accordion.classList.remove('isActive');
      } else {
        accordion.classList.add('isActive');
      }
    });
  });
});
